"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPastePreProcess;

var _convertGoogleToHTML = _interopRequireWildcard(require("./convertGoogleToHTML"));

var _convertMSWordToHTML = _interopRequireWildcard(require("./convertMSWordToHTML"));

var _convertEvernoteToHTML = _interopRequireWildcard(require("./convertEvernoteToHTML"));

var _iterables = require("../utils/iterables");

var _genericPasteProcessingConverter = require("./genericPasteProcessingConverter");

var WORD_TEST = /<meta name=ProgId content=Word\.Document>/;
var DOCS_TEST = /id="docs-internal-guid/;
var EVERNOTE_TEST = /style=("|')-.[a-z]-clipboard:true;"/i;
var UNKNOWN = 'unknown';
var pasteSourceMap = [{
  test: DOCS_TEST,
  converter: _convertGoogleToHTML.default,
  converterName: _convertGoogleToHTML.CONVERT_GOOGLE_TO_HTML
}, {
  test: WORD_TEST,
  converter: _convertMSWordToHTML.default,
  converterName: _convertMSWordToHTML.CONVERT_MSWORD_TO_HTML
}, {
  test: EVERNOTE_TEST,
  converter: _convertEvernoteToHTML.default,
  converterName: _convertEvernoteToHTML.CONVERT_EVERNOTE_TO_HTML
}];

function getPastePreProcess(html, formatTransformMap, clearAllStyles, defaultStylesMap) {
  var _ref = pasteSourceMap.find(function (pasteSource) {
    return html.match(pasteSource.test);
  }) || {
    converter: function converter(x) {
      return x;
    },
    converterName: UNKNOWN
  },
      converter = _ref.converter,
      converterName = _ref.converterName; // Add as many converters that take in one {html} arg as wanted


  var composedConverter = (0, _iterables.compose)((0, _genericPasteProcessingConverter.getGenericPasteProcessingConverter)(formatTransformMap, clearAllStyles, defaultStylesMap), converter);
  return {
    converter: composedConverter,
    converterName: converterName
  };
}

module.exports = exports.default;